import { Pipe, PipeTransform, LOCALE_ID, inject } from '@angular/core';
import { formatDate } from '@angular/common';

@Pipe({
    name: 'customShortDate',
    standalone: false
})
export class CustomShortDatePipe implements PipeTransform {
    private locale = inject(LOCALE_ID);

    transform(value: Date | string | number): string {
        let format = 'shortDate';
        if (this.locale.startsWith('de')) {
            format = 'dd.MM.yyyy';
        }
        return formatDate(value, format, this.locale);
    }
}
